<div class="row">
    <div class="col-10 offset-1">
        <h2><span class="blueLetters">Frequently</span> asked questions</h2>
    </div>
    <div class="col-10 offset-1" *ngIf="faqArray">
        <nb-accordion>
            <nb-accordion-item *ngFor="let faq of faqArray.faq">
                <nb-accordion-item-header>
                    <div class="row">
                        <div class="col-12">
                            {{ faq.title }}
                        </div>
                    </div>
                </nb-accordion-item-header>
                <nb-accordion-item-body>
                    <div class="row">
                        <div class="col-12">
                            <p>
                                {{ faq.body }}
                            </p>
                        </div>
                    </div>
                </nb-accordion-item-body>
            </nb-accordion-item>
        </nb-accordion>
    </div>
</div>